export enum CloudFunction {
  createAuthenticationTokenForLoginToken = 'createAuthenticationTokenForLoginToken',
  createLoginWithCodeToken = 'createLoginWithCodeToken',
  inviteUsers = 'inviteUsers',
  signUpUser = 'signUpUser',
  joinTeam = 'joinTeam',
  deleteUser = 'deleteUser',
  onSyncPermissionsForUser = 'onSyncPermissionsForUser',
  onSyncPermissions = 'onSyncPermissions',
  triggerReflectionEmail = 'triggerReflectionEmail',
  setCustomUserClaimsForLoggedInUser = 'setCustomUserClaimsForLoggedInUser',
  createStripePaymentIntent = 'createStripePaymentIntent',
  upsertEnrollment = 'upsertEnrollment',
  updateEnrollmentComment = 'updateEnrollmentComment',
  gtmBookingPaidBeacon = 'gtmBookingPaidBeacon',
  sendEnrollmentEmail = 'sendEnrollmentEmail',
  getReminderRecipientsForActivity = 'getReminderRecipientsForActivity',
  getActivityReminderSchedulePreview = 'getActivityReminderSchedulePreview',
  getObfuscatedEnrollment = 'getObfuscatedEnrollment',
  getEnrollmentData = 'getEnrollmentData',
  payForGroup = 'payForGroup',
  payForGroupWithUserCredit = 'payForGroupWithUserCredit',
  payForGroupWithEpassi = 'payForGroupWithEpassi',
  payForGroupWithSwish = 'payForGroupWithSwish',
  payForGroupWithVipps = 'payForGroupWithVipps',
  saveUserRegistrationV3 = 'saveUserRegistrationV3',
  saveUserRegistrationV4 = 'saveUserRegistrationV4',
  createSwishPaymentIntent = 'createSwishPaymentIntent',
  cancelSwishPaymentIntent = 'cancelSwishPaymentIntent',
  createSwishRefundIntent = 'createSwishRefundIntent',
  createVippsPayment = 'createVippsPayment',
  cancelVippsPayment = 'cancelVippsPayment',
  refundVippsPayment = 'refundVippsPayment',
  refundStripePaymentForEnrollment = 'refundStripePaymentForEnrollment',
  createVippsSessionCheckout = 'createVippsSessionCheckout',
  onVippsCheckoutWebhook = 'onVippsCheckoutWebhook',
  getActivePeriodsForUser = 'getActivePeriodsForUser',
  getFreeDropinRewardPreview = 'getFreeDropinRewardPreview',
  getFreeDropinRuleUsage = 'getFreeDropinRuleUsage',
  getCreditForUser = 'getCreditForUser',
  getUserPreviousDiscounts = 'getUserPreviousDiscounts',
  payWithUserCredit = 'payWithUserCredit',
  storeEnrollmentActivityCheckin = 'storeEnrollmentActivityCheckin',
  getEmailRecipientsForActivities = 'getEmailRecipientsForActivities',
  addSsnForEnrollmentUser = 'addSsnForEnrollmentUser',
  addSsnForDropinTicket = 'addSsnForDropinTicket',
  addSsnForPrivateLessonOrder = 'addSsnForPrivateLessonOrder',
  createMailing = 'createMailing',
  cancelMailing = 'cancelMailing',
  onTaskMailingItem = 'onTaskMailingItem',
  onTaskMailingPostmarkBatch = 'onTaskMailingPostmarkBatch',
  onTaskMailingScheduledTrigger = 'onTaskMailingScheduledTrigger',
  onTaskMailingSummary = 'onTaskMailingSummary',
  onPostmarkEventWebhook = 'onPostmarkEventWebhook',
  onTaskFreeDropinReconciliation = 'onTaskFreeDropinReconciliation',
  onTaskRegistrationNotificationsAfterSave = 'onTaskRegistrationNotificationsAfterSave',
  onTaskRecomputeCustomerMetrics = 'onTaskRecomputeCustomerMetrics',
  onTaskAutomatedRemindersForClient = 'onTaskAutomatedRemindersForClient',
  setExpoPushNotificationsTokenForUser = 'setExpoPushNotificationsTokenForUser',
  createCustomTokenForIdToken = 'createCustomTokenForIdToken',
  onAdminWebSignout = 'onAdminWebSignout',
  getEnrollmentsForUser = 'getEnrollmentsForUser',
  getCurrentEnrollmentUser = 'getCurrentEnrollmentUser',
  createEarlyBirdBooking = 'createEarlyBirdBooking',
  createDropinTicket = 'createDropinTicket',
  createDropinTicketForPhone = 'createDropinTicketForPhone',
  createDropinTicketAndInitiateSwishPayment = 'createDropinTicketAndInitiateSwishPayment',
  useDropinTicket = 'useDropinTicket',
  createPaymentTransactionFromDropinTicket = 'createPaymentTransactionFromDropinTicket',
  createSwishPaymentIntentForPaymentTransaction = 'createSwishPaymentIntentForPaymentTransaction',
  createSwishPaymentIntentForPrivateLessonOrder = 'createSwishPaymentIntentForPrivateLessonOrder',
  getPaymentTransactionByDropinTicketId = 'getPaymentTransactionByDropinTicketId',
  getDropinTicketActivationStatus = 'getDropinTicketActivationStatus',
  consumeDropinTicketForReception = 'consumeDropinTicketForReception',
  getDropinCheckinsForActivity = 'getDropinCheckinsForActivity',
  getDropinCheckinsForActivities = 'getDropinCheckinsForActivities',
  getOrCreateUser = 'getOrCreateUser',
  checkDiscountCode = 'checkDiscountCode',
  convertHardCoupleToSoftCouple = 'convertHardCoupleToSoftCouple',
  createDropinTicketManual = 'createDropinTicketManual',
  softDeleteDropinTicket = 'softDeleteDropinTicket',
  updateDropinTicket = 'updateDropinTicket',
  refundDropinTicket = 'refundDropinTicket',
  resendDropinPaymentConfirmation = 'resendDropinPaymentConfirmation',
  createHelpDancerForClient = 'createHelpDancerForClient',
  setHelpDancerForEnrollmentUser = 'setHelpDancerForEnrollmentUser',
  syncEnrollmentUserDetails = 'syncEnrollmentUserDetails',
  changeEnrollmentUserPhone = 'changeEnrollmentUserPhone',
  mergeEnrollmentUsers = 'mergeEnrollmentUsers',
  validateClientEmailConfig = 'validateClientEmailConfig',
  updateClientEmailConfig = 'updateClientEmailConfig',
  inviteAdminUser = 'inviteAdminUser',
  updateUserClientIds = 'updateUserClientIds',
  updateUserRole = 'updateUserRole',
  // Fortnox integration
  initiateFortnoxConnection = 'initiateFortnoxConnection',
  disconnectFortnox = 'disconnectFortnox',
  syncFortnoxTransactions = 'syncFortnoxTransactions',
  manuallyMatchFortnoxTransaction = 'manuallyMatchFortnoxTransaction',
  getFortnoxTransactions = 'getFortnoxTransactions',
  // SEB integration
  initiateSebConnection = 'initiateSebConnection',
  disconnectSeb = 'disconnectSeb',
  syncSebTransactions = 'syncSebTransactions',
  getSebAccounts = 'getSebAccounts',
  selectSebAccount = 'selectSebAccount',
  refreshSebToken = 'refreshSebToken',
  addSebFakeTransaction = 'addSebFakeTransaction',
  rematchSebTransactions = 'rematchSebTransactions',
  sendPrivateLessonsPaymentSuccessEmail = 'sendPrivateLessonsPaymentSuccessEmail',
  sendEmail = 'sendEmail',
  getPrivateLessonConfig = 'getPrivateLessonConfig',
  getPrivateLessonOrder = 'getPrivateLessonOrder',
  createPrivateLessonOrder = 'createPrivateLessonOrder',
  // AI Configuration Query
  queryClientConfigurations = 'queryClientConfigurations',
  // AI Description Generator
  generateActivityDescription = 'generateActivityDescription',
  // Portal Authentication
  requestPortalLoginEmailLink = 'requestPortalLoginEmailLink',
  requestPortalLoginSMS = 'requestPortalLoginSMS',
  setPortalUserClaims = 'setPortalUserClaims',
  // SMS Billing
  smsTopUpAction = 'smsTopUpAction',
  updateSmsConfig = 'updateSmsConfig',
  createSmsStripePaymentIntent = 'createSmsStripePaymentIntent',
  sendCustomSms = 'sendCustomSms',
  // Apple Wallet
  appleWalletPass = 'appleWalletPass',
  appleWalletDropinPass = 'appleWalletDropinPass',
  // Google Wallet
  googleWalletPass = 'googleWalletPass',
  googleWalletDropinPass = 'googleWalletDropinPass',

  // Fritidskortet (EHM)
  fritidskortetLookupOrganization = 'fritidskortetLookupOrganization',
  fritidskortetSubmitPaymentDetails = 'fritidskortetSubmitPaymentDetails',
  fritidskortetGetPaymentStatus = 'fritidskortetGetPaymentStatus',
  fritidskortetConfirmPayout = 'fritidskortetConfirmPayout',
  // ePassi
  epassiInitiatePayment = 'epassiInitiatePayment',
  epassiCancelPayment = 'epassiCancelPayment',
  epassiListConfigs = 'epassiListConfigs',
  epassiSaveConfig = 'epassiSaveConfig',
  // BigQuery Analytics
  queryBigQueryEnrollments = 'queryBigQueryEnrollments',
  queryBigQueryRecentEnrollments = 'queryBigQueryRecentEnrollments',
  queryBigQueryDailyGrid = 'queryBigQueryDailyGrid',
  queryBigQueryWeeklyGrid = 'queryBigQueryWeeklyGrid',
  queryBigQuerySwishThreeMonthSummary = 'queryBigQuerySwishThreeMonthSummary',
  queryBigQuerySwishLastMonthInvoicing = 'queryBigQuerySwishLastMonthInvoicing',
  queryBigQueryClientRevenueSummary = 'queryBigQueryClientRevenueSummary',
  queryBigQueryClientEnrollmentRollingYoY = 'queryBigQueryClientEnrollmentRollingYoY',
  getLastMonthInvoicingSmsStats = 'getLastMonthInvoicingSmsStats',
  runBigQueryInconsistencyReport = 'runBigQueryInconsistencyReport',
  previewResetTestClientOperationalData = 'previewResetTestClientOperationalData',
  applyResetTestClientOperationalData = 'applyResetTestClientOperationalData',
  // Stripe Drop-in & Private Lessons
  createStripePaymentIntentForDropinTicket = 'createStripePaymentIntentForDropinTicket',
  createStripePaymentIntentForPrivateLessonOrder = 'createStripePaymentIntentForPrivateLessonOrder',
  // Customer Metrics
  getCustomerMetrics = 'getCustomerMetrics',
  // Reception Swish Walk-in
  createReceptionSwishSession = 'createReceptionSwishSession',
  cancelReceptionSwishSession = 'cancelReceptionSwishSession',
  // Reception Stripe Terminal (S700) Walk-in
  createReceptionStripeWalkInSession = 'createReceptionStripeWalkInSession',
  cancelReceptionStripeWalkInSession = 'cancelReceptionStripeWalkInSession',
  // Reception Stripe Terminal (S700) payment for an existing enrollment (Trigger Pay)
  createReceptionStripeEnrollmentPayment = 'createReceptionStripeEnrollmentPayment',
  cancelReceptionStripeEnrollmentPayment = 'cancelReceptionStripeEnrollmentPayment',
  sendSlackNotification = 'sendSlackNotification',
  checkUnfinishedEnrollment = 'checkUnfinishedEnrollment',
  getActivityPublicCapacity = 'getActivityPublicCapacity',
  getSuppressionInfoForEmails = 'getSuppressionInfoForEmails',
  // Client email flows (transactional HTML via GENERIC_CONTENT shell)
  upsertClientEmailFlowTemplate = 'upsertClientEmailFlowTemplate',
  previewClientEmailFlow = 'previewClientEmailFlow',
  sendTestClientEmailFlow = 'sendTestClientEmailFlow',
  listClientEmailTemplateSends = 'listClientEmailTemplateSends',
  getClientEmailTemplateSend = 'getClientEmailTemplateSend',
  startPortalViewAs = 'startPortalViewAs',
  redeemPortalViewAs = 'redeemPortalViewAs',
  getPortalViewAsSession = 'getPortalViewAsSession',
  endPortalViewAs = 'endPortalViewAs'
}
